import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=b0cef888&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=ts&"
export * from "./Cover.vue?vue&type=script&lang=ts&"
import style0 from "./Cover.vue?vue&type=style&index=0&id=b0cef888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cef888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b0cef888', component.options)
    } else {
      api.reload('b0cef888', component.options)
    }
    module.hot.accept("./Cover.vue?vue&type=template&id=b0cef888&scoped=true&", function () {
      api.rerender('b0cef888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/Cover.vue"
export default component.exports